<div class="data-generation-section">
  <h5 [translationEditableDirective]="data.nameTrnKey">
    {{ data.nameTrnKey | translate : { defaultValue: data.name } }}
  </h5>

  <div class="grid">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="STARTED_AT">{{
        'STARTED_AT' | translate
      }}</label>
      <span *ngIf="data.startedAt">{{
        data.startedAt | formatDate : 'DD-MM-yyyy HH:mm:ss'
      }}</span>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="ENDED_AT">{{
        'ENDED_AT' | translate
      }}</label>
      <span *ngIf="data.finishedAt">{{
        data.finishedAt | formatDate : 'DD-MM-yyyy HH:mm:ss'
      }}</span>
    </div>

    <div class="field is-narrow" *ngIf="!data.simple">
      <label class="label" translationEditableDirective="TIME_ELAPSED">{{
        'TIME_ELAPSED' | translate
      }}</label>
      <div>
        <span
          class="is-relative"
          [translationEditableModalShowIcon]="true"
          [translationEditableModalDirective]="[
            'HOURS',
            'HOUR',
            'MINUTES',
            'MINUTE',
            'SECONDS',
            'SECOND'
          ]"
          >{{ toMap(data.elapsed) | countdown }}</span
        >
      </div>
    </div>

    <div class="field is-narrow" *ngIf="!data.simple">
      <label class="label" translationEditableDirective="TIME_LEFT">{{
        'TIME_LEFT' | translate
      }}</label>
      <div>
        <span
          class="is-relative"
          [translationEditableModalShowIcon]="true"
          [translationEditableModalDirective]="[
            'HOURS',
            'HOUR',
            'MINUTES',
            'MINUTE',
            'SECONDS',
            'SECOND'
          ]"
        >
          {{ toMap(data.estimatedLeft) | countdown }}</span
        >
      </div>
    </div>

    <div class="field is-narrow" *ngIf="!data.simple">
      <label class="label" translationEditableDirective="ITEMS">{{
        'ITEMS' | translate
      }}</label>
      <span
        >{{ data.processed | number }}
        <span translationEditableDirective="OF">{{ 'OF' | translate }}</span>
        {{ data.totalItems | number }}
      </span>
    </div>

    <div class="field is-narrow is-progress" *ngIf="!data.simple">
      <label class="label" translationEditableDirective="PROGRESS">{{
        'PROGRESS' | translate
      }}</label>
      <progressbar
        [total]="data.totalItems"
        [current]="data.processed"
        [error]=""
        [showLabel]="false"
      ></progressbar>
    </div>
  </div>

  <div
    class="running-animation is-flex is-align-items-center"
    *ngIf="data.state.name !== states.NOT_RUNNING"
  >
    <ng-lottie
      width="40px"
      height="20px"
      containerClass=""
      [options]="options"
      *ngIf="data.state.name === states.RUNNING"
    />

    <img
      *ngIf="data.state.name === states.FINISHED"
      width="20px"
      src="/assets/done-icon.svg"
    />

    <img
      *ngIf="data.state.name === states.ERRORED"
      width="20px"
      src="/assets/error.svg"
    />

    <img
      *ngIf="data.state.name === states.STOPPED"
      width="20px"
      src="/assets/abort-icon.svg"
    />

    <span
      class="pl-2"
      [translationEditableDirective]="data.state.translationKey"
    >
      {{
        data.state.translationKey
          | translate : { defaultValue: data.state.title }
      }}
    </span>
  </div>
</div>
